import { vMaska } from 'maska/vue'

export default function (app) {
  app.directive('maska', vMaska)
}

